import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpenReader } from "@fortawesome/free-solid-svg-icons";
import { RiyalImgBLK } from '../../components/common/RiyalImg';
import { useLangUrl } from '../../utilities/useLangUrl';

function CartBooksSummary({ totalBooks, totalBooksPrice, t }) {
    const navigate = useNavigate();
    const langUrl = useLangUrl()

    return (
        <div className="col-11 col-md-3 bg-white rounded text-center my-3 mx-auto me-md-4 p-2 d-flex flex-column justify-content-between">
            <div className="mb-3">
                <h6 className="mb-2">{t("BookCart")}</h6>
                {totalBooks ?
                    <>
                        <p>{t("BookQty")}: <span className="c-darkOrange fs-6">{totalBooks}</span></p>
                        <p>{t("TotalPrice")}: <br /><span className="c-darkBeige fs-6">{totalBooksPrice}<RiyalImgBLK /></span></p>
                    </> :
                    <p className="text-warning">{t("CartEmpty")}</p>
                }
            </div>
            <div className="d-flex flex-column">
                <button className={`btn-masar text-white m-1 ${!totalBooks ? "btn-disabled" : "btn-dark-orange"}`}
                    disabled={!totalBooks}
                    onClick={() => {
                        sessionStorage.setItem('paymentType', 'books');
                        navigate(`${langUrl}/payment`)
                    }}>{t("CompletePurchase")}</button>
                <button className="btn-masar btn-light-beige text-white m-1"
                    // disabled={!totalBooks}
                    onClick={() => navigate(`${langUrl}/masarLibrary`)}><FontAwesomeIcon icon={faBookOpenReader} /> {t("Library")}</button>
            </div>
        </div>
    )
};

function CartOrdersSummary({ t, totalOrders, totalOrdersPrice }) {
    const navigate = useNavigate();
    const langUrl = useLangUrl()

    return (
        <div className="col-11 col-md-3 text-center my-3 mx-auto me-md-4 px-2 d-flex flex-column justify-content-between">
            <div className="mb-3">
                <h6 className="mb-2">{t("OrdersCart")}</h6>
                {totalOrders ?
                    <>
                        <p>{t("TotalPrice")}: <br /><span className="c-darkBeige fs-6">{totalOrdersPrice}<RiyalImgBLK /></span></p>
                    </> :
                    <p className="text-warning">{t("CartEmpty")}</p>
                }
            </div>
            <div className="d-flex flex-column">
                <button className={`btn-masar text-white m-1 ${!totalOrders ? "btn-disabled" : "btn-dark-orange"}`}
                    disabled={!totalOrders}
                    onClick={() => {
                        sessionStorage.setItem('paymentType', 'services');
                        navigate(`${langUrl}/payment`)
                    }}>{t("CompletePurchase")}</button>
            </div>
        </div>
    )
};

export { CartBooksSummary, CartOrdersSummary };